import { useTheme } from "@mui/material/styles";

export const Logo = () => {
  const theme = useTheme();
  const fillColor = theme.palette.primary.main;
  return <img style={{ height: "100%", width: "100%" }} src="/icon.svg" />;
};
